import React from "react";
import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material";
import { FaInfoCircle } from "react-icons/fa";

const RequestIconButton = ({ label = "Pedido", onClick, disabled = false }) => {

    const theme = useTheme();
    return (
        <IconButton color="primary" disabled={disabled} onClick={onClick}>
            <FaInfoCircle size="14px" />
        </IconButton>
    );
}

export default RequestIconButton;
